import lodashClonedeep from 'lodash/cloneDeep';
import { PropTypes } from 'prop-types';
import React, {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import { useIntl } from 'react-intl';
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from 'react-router-dom';
import AccionaButton from '../../../../../components/AccionaButton';
import {
  formReducer,
  formToValidObject,
  validableReducer,
} from '../../../../../components/RegionSelect/Logic';
import RegionSelect from '../../../../../components/RegionSelect/RegionSelect';
import { MainContext } from '../../../../../context/MainContext';
import { listDeliveryNote } from '../../../../../services/api/deliveryNote';
import { getFile } from '../../../../../services/api/files';
import { readRegion, readRegionV2 } from '../../../../../services/api/ocr';
import { listPreDeliveryNote } from '../../../../../services/api/preDeliveryNote';
import {
  allAttrAreTrue,
  formIsValidated,
} from '../../../../../utils/formRules';
import SuccessPage from '../../Utils/SuccessPage';
import SuccessUpdatePage from '../../Utils/SuccessUpdatePage';
import DeliveryForm from './Delivery/form';
import {
  PRE_DELIVERY_NOTES_ATTRS,
  PRE_DELIVERY_NOTES_ATTRS_CEMEX,
  PRE_DELIVERY_NOTES_MASH_CONTROL_ATTRS,
} from './Delivery/formItems';
import LaboratoryForm from './Laboratory/form';
import ScannedDocTable from './ScannedDocTable';
import fileIcon from '../../../../../style/img/file.png';

const CreateScannedDoc = ({
  formsAttr,
  closeForm,
  initialData,
  model,
  validable,
  loadedTemplate,
  initialCamFileName,
}) => {
  const intl = useIntl();
  const timer = useRef();
  const navigate = useNavigate();
  const { setLoading, setError } = useContext(MainContext);
  const { project } = useOutletContext();
  const { fileName } = useParams();
  const [moveAllRegions, setMoveAllRegions] = useState(false);
  const [formState, dispatchFormState] = useReducer(
    formReducer,
    lodashClonedeep(formsAttr),
  );
  const [formValidate, dispatchValidable] = useReducer(
    validableReducer,
    lodashClonedeep(validable),
  );
  const [regions, setRegions] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formFinished, setFormFinished] = useState(null);
  const [elementsLoaded, setElementsLoaded] = useState(null);
  const [camImageName, setCamImageName] = useState(initialCamFileName);
  const [selectedRegion, setSelectedRegion] = useState('');
  const [unLockedRegion, setUnLockedRegion] = useState('');
  const [forceTooltip, setForceTooltip] = useState(false);
  const [diffTemplate, setDiffTemplate] = useState(false);
  const isXlsxFile = fileName?.includes('xlsx');
  const location = useLocation();
  const [currentFileName, setCurrentFileName] = useState(fileName);

  const pid = project.id_project;
  const usedPreRegistered = location.pathname.includes('readDocument');
  const notValidated = location.pathname.includes('noValidated');

  const searchAndUpdatePreRegisteredDoc = useCallback(
    async (value) => {
      dispatchFormState({
        field: 'docket_number',
        type: 'updateFormStatus',
        status: 'loading',
      });
      if (model === 'delivery') {
        listPreDeliveryNote({
          page: 1,
          size: 5,
          filters: {
            pid,
            docket_number: value,
            used: usedPreRegistered || notValidated ? 0 : 1,
          },
        }).then((result) => {
          dispatchFormState({
            field: 'docket_number',
            type: 'updateFormStatus',
            status: null,
          });
          if (isXlsxFile) {
            dispatchFormState({
              field: 'supplier_id',
              type: 'updateFormField',
              value: 'Cemex',
            });
          }
          if (result?.data?.data.length > 0) {
            const preDeliveryNote = result.data.data[0];
            if (preDeliveryNote.docket_number === Number(value)) {
              setCamImageName(preDeliveryNote.image_name);
              PRE_DELIVERY_NOTES_ATTRS.forEach((attr) => {
                if (attr === 'arriving_date') {
                  let [year, month, day] = preDeliveryNote[attr].split('-');
                  if (month === undefined) {
                    [day, month, year] = preDeliveryNote[attr].split('/');
                  }
                  dispatchFormState({
                    field: attr,
                    type: 'updateFormField',
                    value: `${day}/${month}/${year}`,
                  });
                } else {
                  if (attr.includes('time')) {
                    const [hours, minutes] = preDeliveryNote[attr].split(':');
                    preDeliveryNote[attr] = `${hours}:${minutes}`;
                  }
                  dispatchFormState({
                    field: attr,
                    type: 'updateFormField',
                    value: preDeliveryNote[attr],
                  });
                }
              });
              if (preDeliveryNote.model === 'cemex') {
                PRE_DELIVERY_NOTES_ATTRS_CEMEX.forEach((attr) => {
                  if (attr.includes('time')) {
                    const [hours, minutes] = preDeliveryNote[attr].split(':');
                    preDeliveryNote[attr] = `${hours}:${minutes}`;
                  }
                  dispatchFormState({
                    field: attr,
                    type: 'updateFormField',
                    value: preDeliveryNote[attr],
                  });
                });
              }
              if (preDeliveryNote['mash_control'])
                PRE_DELIVERY_NOTES_MASH_CONTROL_ATTRS.forEach((attr) => {
                  dispatchFormState({
                    field: attr,
                    type: 'updateFormField',
                    value: preDeliveryNote[attr],
                  });
                });
              dispatchFormState({
                field: 'elements',
                type: 'updateFormField',
                value: preDeliveryNote.elements || '',
              });
            }
          }
        });
        listDeliveryNote({ filters: { docket_number: value } }).then(
          (result) => {
            if (result?.data?.data.length > 0) {
              const currentDocket_number =
                initialData?.regionsValue?.docket_number.toString();
              if (value === currentDocket_number) {
                dispatchFormState({
                  field: 'docket_number',
                  type: 'removeErrorStatus',
                  error: [{ id: 'docket_number.inDB' }, {}],
                });
              } else {
                dispatchFormState({
                  field: 'docket_number',
                  type: 'addErrorStatus',
                  error: [{ id: 'docket_number.inDB' }, {}],
                });
              }
            } else {
              dispatchFormState({
                field: 'docket_number',
                type: 'removeErrorStatus',
                error: [{ id: 'docket_number.inDB' }, {}],
              });
            }
          },
        );
      } else {
        listDeliveryNote({
          project: pid,
          filters: { docket_number: value },
        }).then((result) => {
          dispatchFormState({
            field: 'docket_number',
            type: 'updateFormStatus',
            status: null,
          });
          if (result?.data?.data.length > 0) {
            dispatchFormState({
              field: 'docket_number',
              type: 'removeErrorStatus',
              error: [{ id: 'docket_number.notInDB' }, {}],
            });
          } else {
            dispatchFormState({
              field: 'docket_number',
              type: 'addErrorStatus',
              error: [{ id: 'docket_number.notInDB' }, {}],
            });
          }
        });
      }
    },
    [
      model,
      pid,
      usedPreRegistered,
      notValidated,
      isXlsxFile,
      initialData?.regionsValue?.docket_number,
    ],
  );

  const onClickLock = (data) => {
    if (unLockedRegion === '' && !formState[data].loading) {
      setUnLockedRegion(data);
      setSelectedRegion(data);
    }
    if (unLockedRegion === data && !formState[data].loading) {
      readAndUpdateRegion(regions.find((reg) => reg.data === data));
      setUnLockedRegion('');
      setSelectedRegion('');
    }
  };

  const checkAndSetMoveAllRegions = (newState) => {
    for (const property in formState)
      if (formState[property].loading === 'loading') return;
    setMoveAllRegions(newState);
  };

  const updateMoveAllRegions = () => {
    const indexEl = elementsLoaded.regions.findIndex(
      (r) => r.data === 'compound',
    );
    if (moveAllRegions)
      regions
        .slice(0, indexEl === -1 ? regions.length : indexEl)
        .map((reg) => readAndUpdateRegion(reg));
    setMoveAllRegions(false);
  };

  const onChange = (regs) => {
    setRegions(regs);
  };

  const readOtherRegions = (otherRegions) =>
    otherRegions.map((reg) => readAndUpdateRegion(reg));

  const onBack = () => {
    return document.referrer.toLowerCase().includes('ehe')
      ? window.location.assign(document.referrer)
      : navigate(-1);
  };

  const recreateRegions = (templateRegions) => {
    const regions = templateRegions.map((x, index) => {
      x.index = index;
      x.isSelected = false;
      x.isVisible = true;
      return x;
    });
    return regions;
  };

  const updateForm = (label, value) => {
    if (formValidate[label]) dispatchValidable({ type: false, key: label });
    if (label === 'docket_number') {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        searchAndUpdatePreRegisteredDoc(value);
      }, 4000);
    }
    if (label.includes('compressive_strength'))
      dispatchValidable({ type: false, key: 'compressive_strength' });

    dispatchFormState({
      field: label,
      type: 'updateFormField',
      value: value,
    });
  };

  const readAndUpdateRegion = (region) => {
    dispatchFormState({
      field: region.data,
      type: 'updateFormStatus',
      status: 'loading',
    });
    setUnLockedRegion('');
    if (region.data === 'compressive_strength')
      readRegionV2(fileName, region).then((result) => {
        dispatchFormState({
          field: region.data,
          type: 'updateFormStatus',
          status: null,
        });
        updateForm(region.data, result);
      });
    else
      readRegion(fileName, region).then((result) => {
        dispatchFormState({
          field: region.data,
          type: 'updateFormStatus',
          status: null,
        });
        updateForm(region.data, result);
      });
  };

  const finishForm = async () => {
    if (
      !formIsValidated(formState) ||
      unLockedRegion !== '' ||
      !allAttrAreTrue(formValidate)
    ) {
      setForceTooltip(true);
      const inputsErrors = document.querySelectorAll('div.input-err').length;
      const fieldErrors = document.querySelectorAll(
        'div.select-multiple input[type="text"]',
      );
      let flagControl = true;
      const elementContent =
        window.location.hostname === 'localhost'
          ? window
          : document.querySelector('.content');

      if (inputsErrors >= 1) {
        elementContent.scroll({ top: 0, left: 0, behavior: 'smooth' });
      } else
        fieldErrors.forEach((element) => {
          if (
            window.getComputedStyle(element).outline.includes('solid') &&
            flagControl
          ) {
            elementContent.scroll({
              top: element.offsetTop,
              left: 0,
              behavior: 'smooth',
            });
            flagControl = false;
          }
        });
    } else {
      try {
        setLoading(true);
        if (formState.slump?.value === 0 || formState.slump?.value === '')
          formState.slump.value = null;
        if (formState.specimens_number?.value === '')
          formState.specimens_number.value = 0;
        const formObject = formToValidObject(formState);
        formObject['camFileName'] = camImageName || '';
        const closemsg = await closeForm(
          fileName.includes('xlsx') ? [] : regions,
          formObject,
          currentFileName,
        );
        setLoading(false);
        if (Object.keys(loadedTemplate).length !== 0) {
          setDiffTemplate(checkDiffTemplate());
        }
        setFormFinished(closemsg);
      } catch (error) {
        setLoading(false);
        setError({
          errorType: 'CREATE_SCANNED_DOCUMENT_ERROR',
          status: error.status || 500,
        });
      }
    }
  };

  const onClickTable = (event, region) => {
    event.preventDefault();
    setSelectedRegion(region.data);
  };

  const checkDiffTemplate = () => {
    let check = false;
    loadedTemplate.regions.forEach((templateRegion) => {
      if (regions.data !== 'provider' && regions.data !== 'CIF') {
        const region = regions.find(
          (region) => region.data === templateRegion.data,
        );
        if (
          !(
            region.x === templateRegion.x &&
            region.y === templateRegion.y &&
            region.width === templateRegion.width &&
            region.height === templateRegion.height
          )
        )
          check = true;
      }
    });
    return check;
  };

  const formSelector = () => {
    const RegionSelector = (
      <div className="row row-project">
        <div className="col-xs-12 col-sm-9 col-md-9">
          <div
            className="col-xs-12 col-sm-12 col-md-12"
            style={{ paddingRight: '0px' }}
          >
            <RegionSelect
              regions={regions}
              constraint
              onChange={onChange}
              selectedRegion={selectedRegion}
              setSelectedRegion={setSelectedRegion}
              moveAllRegions={moveAllRegions}
              unLockedRegion={unLockedRegion}
              onClickLock={onClickLock}
              updateMoveAllRegions={updateMoveAllRegions}
              style={{
                border: '1px solid #F1F1F1',
                ...(fileName === 'xlsx.png'
                  ? {
                      maxWidth: '100%',
                      minHeight: '1000px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }
                  : {}),
              }}
              disableLocks={isXlsxFile}
            >
              <img
                alt="region-select-img"
                style={{ userSelect: 'none' }}
                id="region-select-canvas"
                src={selectedFile}
              />
            </RegionSelect>
          </div>
          <div
            className="col-xs-12 col-sm-12 col-md-12"
            style={{ marginLeft: '-5px' }}
          >
            <div className="form-row row-bottom" style={{ marginTop: '10px' }}>
              <AccionaButton
                id="saveTemplateBtn"
                htmlType="submit"
                onClick={finishForm}
                msg={intl.formatMessage({ id: 'save' })}
                classIcon="icon fas fa-check"
              />
              <AccionaButton
                msg={intl.formatMessage({ id: 'back' })}
                onClick={onBack}
                classIcon="icon fas fa-chevron-left"
                style={{ float: 'right', marginRight: '-20px' }}
              />
            </div>
          </div>
        </div>
        <div
          className="col-xs-12 col-sm-3 col-md-3"
          style={{ paddingRight: '30px' }}
        >
          <ScannedDocTable
            updateForm={updateForm}
            forceTooltip={forceTooltip}
            setForceTooltip={setForceTooltip}
            formState={formState}
            onClick={onClickTable}
            selectedRegion={selectedRegion}
            regions={regions}
            unLockedRegion={unLockedRegion}
            onClickLock={onClickLock}
            formValidate={formValidate}
            dispatchValidable={dispatchValidable}
            readOtherRegions={readOtherRegions}
            disableLocks={isXlsxFile}
            disableReload={isXlsxFile}
          />
        </div>
      </div>
    );
    const props = {
      formState: formState,
      updateForm: updateForm,
      moveAllRegions: moveAllRegions,
      updateMoveAllRegions: checkAndSetMoveAllRegions,
      forceTooltip: forceTooltip,
    };
    switch (model) {
      case 'delivery':
        return (
          <DeliveryForm
            {...props}
            hideMoveAllRegionsButton={isXlsxFile || !regions.length}
            onImageLoaded={(data) => {
              if (data) {
                getFile(data.fileName, 'delivery').then(
                  ({ data: dataFile }) => {
                    setSelectedFile(URL.createObjectURL(dataFile));
                    setCurrentFileName(data.fileName);
                  },
                );
              } else {
                setSelectedFile(fileIcon);
                setCurrentFileName(fileName);
              }
            }}
          >
            {RegionSelector}
          </DeliveryForm>
        );
      case 'laboratory':
        return <LaboratoryForm {...props}>{RegionSelector}</LaboratoryForm>;
      default:
        return <></>;
    }
  };

  useEffect(() => {
    async function loadFile(name) {
      setLoading(true);
      try {
        const file = await getFile(name, model);
        setSelectedFile(URL.createObjectURL(file.data));
      } catch (error) {
        setLoading(false);
        if (error.response.status === 404) {
          setSelectedFile(fileIcon);
        } else {
          setError({
            errorType: 'errorType',
            status: 'status',
          });
        }
      }
    }
    loadFile(fileName);
    if (initialData) setElementsLoaded(initialData);
  }, [fileName, setLoading, initialData, model, setError]);

  useEffect(() => {
    if (!formFinished) {
      dispatchFormState({
        field: 'project',
        type: 'updateFormField',
        value: project.normative_data.name,
      });
      if (elementsLoaded) {
        setRegions(recreateRegions(elementsLoaded.regions));
        let objkeys = Object.keys(elementsLoaded.form);
        let reloadPreregister = elementsLoaded.form['arriving_time'];
        objkeys.forEach((key) => {
          dispatchFormState({
            field: key,
            type: 'updateFormField',
            value: elementsLoaded.form[key],
          });
        });
        if (elementsLoaded.regionsValue) {
          elementsLoaded.regions.forEach((reg) => {
            const dType = reg.data;
            const value = elementsLoaded.regionsValue[dType];
            if (!reloadPreregister & (dType === 'docket_number'))
              searchAndUpdatePreRegisteredDoc(value);
            dispatchFormState({
              field: dType,
              type: 'updateFormField',
              value: elementsLoaded.regionsValue[dType],
            });
          });
        } else {
          const indexEl = elementsLoaded.regions.findIndex(
            (r) => r.data === 'compound',
          );
          elementsLoaded.regions
            .slice(0, indexEl === -1 ? elementsLoaded.regions.length : indexEl)
            .forEach((reg) => {
              dispatchFormState({
                field: reg.data,
                type: 'updateFormStatus',
                status: 'loading',
              });
              if (reg.data === 'compressive_strength') {
                readRegionV2(fileName, reg).then((result) => {
                  dispatchFormState({
                    field: reg.data,
                    type: 'updateFormStatus',
                    status: null,
                  });
                  dispatchFormState({
                    field: reg.data,
                    type: 'updateFormField',
                    value: result,
                  });
                });
              } else {
                readRegion(fileName, reg).then((result) => {
                  dispatchFormState({
                    field: reg.data,
                    type: 'updateFormStatus',
                    status: null,
                  });
                  if (reg.data === 'docket_number') {
                    searchAndUpdatePreRegisteredDoc(result);
                  }
                  dispatchFormState({
                    field: reg.data,
                    type: 'updateFormField',
                    value: result,
                  });
                });
              }
            });
        }
        setLoading(false);
      }
    }
  }, [
    elementsLoaded,
    fileName,
    formsAttr,
    setLoading,
    formFinished,
    project.normative_data.name,
    searchAndUpdatePreRegisteredDoc,
  ]);

  if (formFinished && diffTemplate) {
    return (
      <SuccessUpdatePage
        formatmsg={formFinished}
        loadedTemplate={loadedTemplate}
        regions={regions}
        customFinishButton={onBack}
      />
    );
  } else if (formFinished) {
    return <SuccessPage formatmsg={formFinished} customFinishButton={onBack} />;
  }
  return formSelector();
};

CreateScannedDoc.defaultProps = {
  initialData: null,
  validable: false,
  loadedTemplate: undefined,
  initialCamFileName: '',
};

CreateScannedDoc.propTypes = {
  formsAttr: PropTypes.object.isRequired,
  closeForm: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  initialData: PropTypes.object,
  validable: PropTypes.object,
  loadedTemplate: PropTypes.object,
  initialCamFileName: PropTypes.string,
};

export default CreateScannedDoc;
